/* eslint-disable no-octal-escape */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import * as yup from "yup";

import QRCode from "react-qr-code";
import clsx from "clsx";

import Footer from "components/Molecules/Footer";
import LoginSection from "components/Molecules/Login";
import Button from "components/Atoms/Button";
import Text from "components/Atoms/Text";
import Loader from "components/Atoms/Loaders/loader";
import Link from "components/Atoms/Link";
import { useAppDispatch, useTypedSelector } from "store/store";
import { TLoginForm, TProgram } from "./types";
import { authThunk } from "./auth.thunk";
import { mobileQRs } from "helpers/constants";
import Image from "components/Atoms/Image";
import { setImageSignature } from "helpers/utils";
import { verifyAppVersion } from "components/shared/MyGarage/mygarage.thunks";

type IProps = {};

const RAPIDLogo = ({ logoUrl }: { logoUrl: string }) => {
  return <Image src={logoUrl} alt="logo" width={150} height={'auto'} />
}

export const loginSchema = yup.object<TLoginForm>().shape({
  username: yup.string().email('Enter valid email ID').required("Username is required."),
  password: yup.string().max(25, "Password cannot be more than 25 characters").required("Password is required."),
});

const RAPID_IS_MORE = [{
  id: 'searchforparts',
  label: 'Search for parts'
}, {
  id: 'placeorders',
  label: 'Place orders'
}
  , {
  id: 'makeonlinepayments',
  label: 'Make online payments'
}, {
  id: 'viewstatementsandinvoices',
  label: 'View statements and invoices'
}, {
  id: 'returnsusingrapid',
  label: 'Return parts online'
}]


const servingStates = [{
  state: 'fl',
  imageUrl: '/fl.png'
}, {
  state: 'pr',
  imageUrl: '/pr.png'
}, {
  state: 'al',
  imageUrl: '/al.png'
}, {
  state: 'ga',
  imageUrl: '/ga.png'
}, {
  state: 'sc',
  imageUrl: '/sc.png'
}, {
  state: 'nc',
  imageUrl: '/nc.png'
}, {
  state: 'tn',
  imageUrl: '/tn.png'
}, {
  state: 'va',
  imageUrl: '/va.png'
},
];

const LoginPage: React.FC<IProps> = () => {
  const dispatch = useAppDispatch();
  const auth = useTypedSelector(state => state.auth);
  const dataObjects = auth.programs;

  useEffect(() => {
    dispatch(authThunk.getImageSignatures());
    dispatch(authThunk.getLoginSections());

    const fiveMins = 1000 * 60 * 5;
    dispatch(verifyAppVersion());
    setInterval(() => {
      dispatch(verifyAppVersion());
    }, fiveMins);
  }, []);

  return (
    <div id="tw">
      <div className="flex flex-col h-screen">
        {/* Header with Logo */}
        <div className="flex items-center justify-center py-3">
          <RAPIDLogo logoUrl={dataObjects?.pageLogoUrl || "/rapid-tph-logo.png"} />
        </div>
        {/* Main section */}
        <div className="flex flex-1 flex-col md:transition-all">
          <div className="lg:h-[385px] flex flex-col-reverse lg:flex-row flex-wrap bg-gray-820">
            <div className="md:h-[385px] flex-1 flex flex-wrap md:bg-diagonal md:bg-cover">
              <div className="flex-1 h-[385px] before:border-r-0 before:border-b-0 before:absolute before:h-0 before:w-0 before:border-l-[200px] before:border-l-transparent before:border-t-[385px] before:border-t-blue-950 before:border-solid before:right-0 before:top-0 relative md:w-3/5 p-10 flex md:flex-initial flex-col gap-4 items-baseline justify-center bg-gray-950 md:bg-transparent">
                <div className="w-60 self-center md:self-start ">
                  <Text className="text-white text-3xl">RAPID IS SO MUCH MORE!</Text>
                </div>
                <div>
                  <ul className="p-0 flex flex-col gap-2 list-none">
                    {RAPID_IS_MORE.map((more, i) => {
                      return <li className="before:content-['\2713'] before:text-gray-980 before:p-3 before:text-2xl text-lg text-white" key={more.id}>
                        {more.label}
                      </li>
                    })}
                  </ul>
                </div>
              </div>
              <div className="relative h-inherit p-10 md:pl-0 flex justify-center md:justify-end flex-wrap flex-1 bg-blue-950 md:bg-transparent">
                <div className="md:absolute md:-left-20 md:max-w-64">
                  <ul className="p-0 text-white list-disc text-base">
                    <li >Available FREE on iOS and Android</li>
                    <li>Fast online ordering through our Rapid Catalog.</li>
                  </ul>
                </div>
                <div>
                  <div className="flex flex-col gap-5 items-center">
                    <div className="flex flex-col gap-10">
                      {mobileQRs.map((qr: any) => {
                        return <div className="flex flex-col gap-y-3" key={qr.platform}>
                          <div className="flex p-1 bg-white w-[88px] h-[88px] self-end" >
                            <div className="lg: relative">
                              <Image className="p-2 absolute -left-10 bottom-0 rounded-l-3xl bg-black" src={qr.playIcon} width={35} height={35} alt="store icons" />
                              <Link href={qr.link} target="_blank">
                                <QRCode value={qr.link} size={80} />
                              </Link>
                            </div>
                          </div>
                          <Link href={qr.link} target="_blank" key={qr.platform}>
                            <Image src={qr.imageUrl} alt={qr.platform} width={120} height={40} />
                          </Link>
                        </div>
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <div className="relative h-full flex items-center justify-center">
                <LoginSection />
                <div className="absolute -right-[65px] rotate-90 top-1/2">
                  <Button href="/online-id-req-form" variant="contained" className="bg-gray-950 rounded-none">Create an Account</Button>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:px-10">
            <div className="w-full p-4 pb-0 flex bg-gray-850">
              <div className="w-full flex flex-col flex-1 items-center justify-center">
                {dataObjects ? <>
                  <div className="w-full flex-1 flex flex-col items-center justify-center gap-1">
                    {dataObjects?.sections.map((section: any, i: number) => {
                      return <React.Fragment key={i}>
                        <div className="w-full flex flex-col items-center gap-5">
                          <div>
                            <Text variant="body1" className="text-red-950 text-2xl md:text-3xl font-extrabold text-uppercase">{section.title}</Text>
                          </div>
                          <div className="w-full flex md:grid grid-cols-2 grid-rows-2 lg:flex gap-5 flex-col lg:flex-row flex-wrap justify-center">
                            {section?.programs?.map((program: TProgram, j: number) => {
                              return <Link target="_blank" imageSignature={auth.imageSignatureParams} href={program?.link} className={clsx("px-12 py-6 flex-1 flex flex-col md:flex-row gap-5 items-center justify-center rounded-lg bg-white", [{ 'row-span-2': j === 0, 'col-start-2': section.programs?.length - 1 === j }])} key={i + j}>
                                <div className="flex gap-y-2">
                                  <div className="bg-blue-950 rounded-full w-20 h-20 flex items-center justify-center">
                                    <Image src={setImageSignature(program.iconUrl, auth.imageSignatureParams || "")} alt="program-icon" width={80} height={80} />
                                  </div>
                                </div>
                                <div className="flex flex-col gap-3 items-center">
                                  <Text className={clsx(`text-2xl text-center font-extrabold text-black`)}>{program.programName}</Text>
                                  {program?.brands && <div className="flex gap-3 max-w-40 flex-wrap items-center">
                                    {program?.brands.map((brand, bIndex) => {
                                      return <Image src={setImageSignature(brand, auth.imageSignatureParams || "")} width={70} height="auto" alt="brand-image" key={`brand-${bIndex}`} />
                                    })}
                                  </div>}
                                </div>
                              </Link>
                            })}
                          </div>
                        </div>
                        {(i < dataObjects.sections.length - 1) && <hr />}
                      </React.Fragment>
                    })}
                  </div>
                </> : auth.loading ? <Loader /> : null}
              </div>
            </div>

            <div className="pb-4 flex flex-col items-center justify-center gap-5 bg-gray-850">
              <Text className="text-gray-950">Serving Customers Across 7 States and Puerto Rico</Text>
              <div className="flex items-center justify-center flex-wrap gap-1">
                {servingStates.map(state => {
                  return <div className="rounded-full bg-slate-400" key={state.state}>
                    <Image src={state.imageUrl} width={60} height={60} alt={state.state} />
                  </div>
                })}
              </div>
            </div>
          </div>
        </div>
        {/* Main section ends */}

        {/* Footer */}
        <div className="">
          <Footer />
        </div>
        {/* Footer Ends */}
      </div>
    </div>
  );
};

export default LoginPage;
